// @flow
import React, { Component } from 'react';
import './About.css';
import { Link } from 'react-router-dom';


export default class About extends Component {
    render() {

        let content = (
            <div>
                <blockquote>
                Układ elementów, w których stykamy się ze zjawiskiem podobieństwa
                i różnicy, powtórzenia i symetrii jako źródła przyjemności,
                obejmuje zarówno czynności nawlekania koralików, jak i
                projektowania stron książek, (…) Rozciąga się także poza te
                granice, sięgając w dziedzinę rytmów i tempa, mowy i muzyki, nie
                mówiąc już o strukturach społecznych i teoriach idei.”

                    <div className="ln-quote-author">
                    E.H. Gombrich Zmysł porządku. O psychologii sztuki dekoracyjnej
                    </div>

                </blockquote>

                <p>
                Podążanie za tym rytmem, symetrią i powtórzeniem, naturalnie
                zaprowadziło mnie w obszary wzorów i deseni. W końcowym wzorze
                kumuluje się wszystko, co sprawia mi radość, porządkowanie
                elementów, wyłanianie się struktury a wreszcie wartość estetyczna.
                Na tej bazie powstała Laura Nor, jako owoc dotychczasowych
                poszukiwań ale też jako propozycja dla każdego kto tęskni za
                wzorem i kolorem we własnej przestrzeni do życia.
                </p>

                <p>
                Moje projekty można wykorzystać na tapetach w salonie, tkaninach
                obiciowych, pościeli a nawet plakatach. Możliwości jest tyle ile
                pomysłów na ich zastosowanie. Każdy pomysł może stać się
                początkiem nowego wzoru. Część z nich wraz z propozycjami
                wykorzystania znajdziesz <Link to="/patterns">tutaj</Link>.
                </p>

                <p>
                Jeśli natomiast chcesz dowiedzieć się więcej na temat licencji,
                zaprojektować coś wspólnie (ty mówisz o inspiracjach i pomysłach
                a ja opierając się na nich tworzę wzór dla ciebie), zadać mi
                pytanie, lub po prostu się przywitać, napisz do mnie na adres <b>kasia@lauranor.com</b>.
                </p>

                <p>
                W wolnych chwilach gdy nie projektuję wzoru, poszukuję go w kolażu.
                Z jakim efektem możesz zobaczyć <a rel="noopener noreferrer" target="_blank" href="http://norlaura.tumblr.com/">tutaj</a>
                </p>

                <p>
                lub w fotografii, tak jak tej islandzkiego mchu, która została
                opublikowana w
                albumie <a rel="noopener noreferrer" target="_blank"  href="https://www.amazon.co.uk/PATTERNITY-Seeing-InspirationalPower-Pattern/dp/184091694X">
                Patternity a new way of seeing The Inspirational Power of Pattern</a>
                </p>

                <div className="col s12 m12 center ln-patternity">
                    <img
                        src="/patternity.png"
                        alt="Patternity a new way of seeing The Inspirational Power of Pattern"></img>
                </div>

                <p>
                    Część moich wzorów i produktów można kupić <Link to="/stores">tutaj</Link>
                </p>
            </div>);

        return (
            <div className="row ln-content">
                <div className="col s12 m4 center ln-laura">
                    <img
                        src="/laura.png"
                        alt="Laura Nor herself"></img>
                </div>

                <div
                    className="col s12 m8 ln-text">
                    { content }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/About/About.js